<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="0"
    :show-close="false"
  >
    <slot name="title">
      <span class="icon">
        <WarningIcon :isHover="false" />
      </span>
      <div class="header">{{ title }}</div>
    </slot>
    <div class="body">
      <div class="content">
        <div class="message_box">
          <slot name="body">
            <p>{{ message }}</p></slot
          >
        </div>
        <div class="btn_box">
          <slot name="btn">
            <CustomButton :styleConfig="confirmBtnConfig" @click="onConfirm">{{ confirmText }}</CustomButton>
            <CustomButton v-if="!hideCancel" :styleConfig="cancelBtnConfig" @click="onCancel">
              {{ cancelText }}
            </CustomButton>
          </slot>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import WarningIcon from '@/components/icon/Warning.vue';
import CustomButton from '@/components/interact/CustomButton.vue';
import { BLACK_COLOR, GREEN_COLOR, RED_COLOR, WHITE_COLOR, GREY_COLOR } from '@/constants/style';

const confirmBtnConfig = {
  BTN_DEFAULT: {
    bgColor: RED_COLOR,
    color: '#ffffff',
    border: `2px solid ${RED_COLOR}`,
    padding: '5px 25px',
    fontSize: '15px'
  },
  BTN_HOVER: {
    bgColor: GREEN_COLOR,
    color: BLACK_COLOR,
    border: `2px solid ${GREEN_COLOR}`,
    padding: '5px 25px',
    fontSize: '15px'
  }
};

const cancelBtnConfig = {
  BTN_DEFAULT: {
    bgColor: WHITE_COLOR,
    color: BLACK_COLOR,
    border: `2px solid ${BLACK_COLOR}`,
    padding: '5px 25px',
    fontSize: '15px'
  },
  BTN_HOVER: {
    bgColor: GREY_COLOR,
    color: WHITE_COLOR,
    border: `2px solid ${GREY_COLOR}`,
    padding: '5px 25px',
    fontSize: '15px'
  }
};

export default {
  name: 'PopOut',
  components: { WarningIcon, CustomButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: function () {
        return this.$t('promotion.redepositBonus.dialog.title');
      }
    },
    message: {
      type: String,
      default: '申请出金将依比例扣除信用金，此动作可能造成您的保证金变动请注意仓位管理风险确认执行'
    },
    confirmText: {
      type: String,
      default: '取消活动'
    },
    cancelText: {
      type: String,
      default: function () {
        return this.$t('common.cancel');
      }
    },
    hideCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      confirmBtnConfig,
      cancelBtnConfig
    };
  },
  methods: {
    disableDialogVisible(bool) {
      this.$nextTick(() => {
        this.$emit('update:visible', bool);
      });
    },
    onConfirm() {
      this.$emit('confirm');
      this.disableDialogVisible(false);
    },
    onCancel() {
      this.$emit('cancel');
      this.disableDialogVisible(false);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  max-width: 400px;
  font-family: Oblivian, PingFangTC-SemiBold;
  font-size: 18px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: $broker-black;
  }
}
.header {
  padding: 15px 20px;
  background-color: $pink-red;
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
}

.icon {
  width: 50px;
  position: absolute;
  top: -18px;
  left: 15px;
}

.body {
  padding: 45px;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  text-align: center;
  .content {
    margin: auto;
    width: 90%;
    .btn_box {
      margin-top: 25px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      :only-child {
        margin: auto;
      }
    }
  }
}
</style>
